export const getEnrollmentInitialState = (
  productParam,
  registrationData = null,
  currentStep = 1,
  productTitle = ''
) => {
  if (!registrationData) {
    registrationData = {
      // TODO: more fields will get populated
      email: '',
      firstName: '',
      lastName: '',
      productParam
    }
  }
  return {
    currentStep,
    productParam,
    productTitle,
    isLoading: false,
    isSubmitting: false,
    isRegistrationStarted: false,
    isRegistrationStartFailed: false,
    changeCompanyCountryStart: false,
    errorMessage: '',
    nonGdprLegalAgreements: [],
    gdprLegalAgreements: [],
    registrationData // nested object that contains values for registration
  }
}

export const enrollmentReducer = (draft, action) => {
  console.log('action:', action)
  switch (action.type) {
    // NOTE: GOTO_STEP_1 is controlled in NextJS (withRegistration check), but is also
    // needed for Step 2 Back button.
    case 'GOTO_STEP_1':
      draft.currentStep = 1
      draft.registrationData = { ...draft.registrationData, ...action.payload }
      return draft
    case 'GOTO_STEP_2':
      draft.currentStep = 2
      draft.registrationData = { ...draft.registrationData, ...action.payload }
      return draft
    case 'GOTO_STEP_3':
      draft.currentStep = 3
      draft.registrationData = { ...draft.registrationData, ...action.payload }
      return draft
    case 'GOTO_STEP_4':
      draft.currentStep = 4
      draft.registrationData = { ...draft.registrationData, ...action.payload }
      return draft
    case 'CHANGED_COMPANY_COUNTRY_START':
      draft.changeCountryStart = true
      draft.registrationData.country = action.payload.country
      return draft
    case 'CHANGED_COMPANY_COUNTRY_COMPLETE':
      draft.changeCountryStart = false
      Object.keys(action).forEach((key) => {
        draft[key] = action[key]
      })
      return draft
    case 'STARTED_REGISTRATION':
      draft.isRegistrationInvalidDomain = false
      draft.isRegistrationInvalidEmailLength = false
      draft.isRegistrationStarted = true
      draft.registrationData.email = action.payload.email
      draft.registrationData.locale = action.payload.locale
      return draft
    case 'STARTED_REGISTRATION_FAILED':
      draft.isRegistrationStartFailed = true
      return draft
    case 'INVALID_EMAIL_DOMAIN':
      draft.isRegistrationInvalidDomain = true
      return draft
    case 'INVALID_EMAIL_LENGTH':
      draft.isRegistrationInvalidEmailLength = true
      return draft
    case 'SUBMIT_REGISTRATION_START':
      draft.registrationData.legalAgreements = []
      draft.registrationData.receiveEmails = false
      Object.keys(action.payload).map((legalType) => {
        if (action.payload[legalType] === true) {
          if (legalType === 'receiveEmails') {
            draft.registrationData.receiveEmails = true
          } else {
            draft.registrationData.legalAgreements.push(legalType)
          }
        }
      })
      draft.errorMessage = ''
      draft.isSubmitting = true
      return draft
    case 'SUBMIT_REGISTRATION_COMPLETE':
      draft.errorMessage = ''
      return draft
    case 'SUBMIT_REGISTRATION_ERROR':
      draft.errorMessage = action.errorMessage
      draft.isSubmitting = false
      return draft
    case 'GENERAL_ERROR':
      draft.errorMessage = action.errorMessage
      return draft
    default:
      return draft
  }
}
